// Syarikat Takaful Malaysia on the add-ons step (ansa-backend-new#579).
//
// Priced by STMB through the server, exactly like Pacific & Orient and Great Eastern (see poiQuote.js):
// "Next" and every add-on toggle re-quote /api/motor/get-quote-takaful-malaysia, and the server records
// that quote for the /motor/store price floor and re-prices again at issuance — STMB's IssueCoverNote
// re-validates every premium member, and the backend holds the order when its re-price is above the
// charge. Without this branch the page would fall into its browser formula and charge a figure STMB
// never quoted. Not Takaful Ikhlas ("TAKAFUL IKHLAS"): a different operator with its own flow.

import { serverPricedPlanFromQuote } from "./poiQuote";

export const TAKAFUL_MALAYSIA_INSURER_NAME = "TAKAFUL MALAYSIA";

export const isTakafulMalaysiaPlan = (plan) =>
	String(plan?.insurer_name || "")
		.trim()
		.toUpperCase() === TAKAFUL_MALAYSIA_INSURER_NAME;

export const takafulMalaysiaPlanFromQuote = serverPricedPlanFromQuote(
	TAKAFUL_MALAYSIA_INSURER_NAME,
	"Takaful Malaysia could not price this quote. Please try again.",
);
